module.exports = __webpack_public_path__ + "media/images/og-0e08236e1ebcff6304f556191dbed1b2.png";